import FreeWillReferralModal from '/@/modules/platformreferral/components/FreeWillReferralModal.vue';

export default class ReferralModalFactory {
  static build(authUser, currentEstate) {
    if (currentEstate?.isStandardPlan) {
      return FreeWillReferralModal;
    }
  }
}
